import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 14:23:24
 * @LastEditTime: 2021-04-22 15:56:20
 * @LastEditors: wangshengqiang
 * @Description: s
 */
import React from 'react';
import { getQueryParam } from '@/utils/tool';
export default (Component => {
  function withQuery(props) {
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      _params: getQueryParam()
    }));
  }

  withQuery._name = Component.name;
  return withQuery;
});